<script>
    import {onMount} from "svelte";
    import {bundlesUrl, bundleUrl, localCatalogUrl} from "../urls";
    import {customFetch} from "../customFetch";
    import Transition from "../components/Transition.svelte";
    import {notifications} from "../notifications";
    import RoundWrapper from "../components/RoundWrapper.svelte";
    import StraightTable from "../components/StraightTable.svelte";
    import {dateView, labelView} from "../tableUtils";
    import Label from "../components/Label.svelte";

    let isLoading = true;
    let tableData = [];

    onMount(load);

    async function load() {
        isLoading = true;

        try {
            let response = await customFetch(bundlesUrl());

            tableData = await response.json();
            tableData = tableData.map((el) => {
                el.UpdatedAt = (new Date(el.UpdatedAt));
                return el;
            });
        } catch (e) {
            notifications.danger(
                `Can't get actual bundles list from server: ${e.message}`
            );
        }

        isLoading = false;
    }

    function formatBytes(bytes, decimals = 2) {
        return (bytes / 1024 / 1024).toFixed(decimals);
    }

    let columns = [
        {title: 'Name', field: 'Name', sortable: true, editView: labelView},
        {title: 'Platform', field: 'Platform', sortable: true, editView: labelView},
        {title: 'Updated At', field: 'UpdatedAt', sortable: true, editView: dateView},
        {title: 'Size (MB)', field: 'Size', sortable: true, editView: function(row, col) {
            return {
                component: Label,
                props: {
                    text: formatBytes(row[col]),
                }
            }
        }},

        {title: 'Link', field: '', sortable: true, defaultValue: new Date(), editView: function (row, col) {
            return {
                component: Label,
                props: {
                    text: `<a href=${bundleUrl(row.ID)} class="hover:underline">Download</a>`
                }
            }
        }},
    ];
</script>

<Transition>
    <RoundWrapper>
        <div class="flex-1 flex items-center space-x-2">
            <a href={localCatalogUrl()} target="_blank">Download local catalog</a><br/>
        </div>
        {#if isLoading}
            <span class="animate-pulse">Loading...</span>
        {:else if tableData.length > 0}
            <StraightTable columns={columns} data={tableData} settings={{editable: false}}/>
        {:else}
            There is nothing to show
        {/if}
    </RoundWrapper>
</Transition>

<style>
    th, td {
        @apply px-2 py-1
    }
</style>
